import { StackDeploymentInfo } from '@/react/common/stacks/types';

import { useGitCheckStatus } from './useGitCheckStatus';
import { useResolvedGitConfig } from './useResolvedGitConfig';

export type GitReferenceStackType =
  | 'docker'
  | 'helm'
  | 'edge'
  | 'edge-helm'
  | 'kubernetes';

export interface UseGitReferenceStatusParams {
  workflowId: number;
  stackId: number;
  stackType: GitReferenceStackType;
  currentDeploymentInfo?: StackDeploymentInfo | null;
}

export function useGitReferenceStatus({
  workflowId,
  stackId,
  stackType,
  currentDeploymentInfo,
}: UseGitReferenceStatusParams) {
  const artifactType =
    stackType === 'edge' || stackType === 'edge-helm' ? 'edgeStack' : 'stack';

  const { hasAuth, effective, divergence, isConfigLoading, isConfigError } =
    useResolvedGitConfig({
      workflowId,
      stackId,
      artifactType,
      currentDeploymentInfo,
    });

  const { status, error } = useGitCheckStatus({
    config: effective,
    hasAuth,
    enableFileCheck: isFileCheckSupported(stackType),
    isConfigLoading,
    isConfigError,
  });

  return { divergence, effective, status, error };
}

export function isFileCheckSupported(stackType: GitReferenceStackType) {
  return stackType !== 'helm' && stackType !== 'edge-helm';
}
